import { Icon } from "components"
import useFadeIn from "logic/hooks/use-fade-in"
import useTilesStagger, {
  TilesStaggerVars,
} from "logic/hooks/use-tiles-stagger"
import { ContactType } from "model/content"
import React, { FunctionComponent } from "react"
import styled from "styled-components"
import tw from "twin.macro"

type ContactInfoProps = ContactType

const ContactInfoContainer = styled.div`
  ${tw`text-dominant xl:grid lg:w-1/2`}
  ${tw`lg:mt-0 lg:pt-12`};
  display: flex;
  flex: 1;
  justify-content: center;
`

const ContactInfoHeading = styled.h2`
  ${tw`flex font-condensed text-4xl leading-none self-start mb-8 z-10 opacity-0`}
  max-width: 19rem;
`

const ContactInfoItems = styled.div`
  z-index: 10;
`

const ContactInfoItem = styled.div`
  ${tw`grid gap-4 mb-8 xl:mb-12 opacity-0`}
  grid-template-columns: min-content 1fr;

  p {
    max-width: 15rem;
  }
`

const ContactInfoIcon = styled(Icon)`
  ${tw`w-8 h-8 overflow-visible`}
  padding: 2px;
  background-color: #ffd000;
`

const ContactInfoIconChat = styled(ContactInfoIcon)`
  padding: 8px;
`

const ContactInfoItemHeading = styled.h3`
  ${tw`font-condensed text-xl`}
`

const ContactInfoPhoneParagraph = styled.p`
  ${tw`leading-loose`}
`

const ContactInfoMail = styled.a`
  &:hover {
    color: #ffd000;
  }
`

const staggerOptions: TilesStaggerVars = {
  stagger: { from: "start", each: 0.2 },
  delay: 0.5,
  slideInOnMobile: false,
}

const ContactInfo: FunctionComponent<ContactInfoProps> = ({
  heading,
  writeHeading,
  writeParagraph,
  phoneHeading,
  phone,
  email,
  locationHeading,
  locationParagraph,
}) => {
  const { tilesRefs } = useTilesStagger(false, staggerOptions)
  const headingRef = useFadeIn(false)

  return (
    <ContactInfoContainer className="contactInfoContainer">
      <ContactInfoItems>
        <ContactInfoHeading ref={headingRef}>{heading}</ContactInfoHeading>
        <ContactInfoItem ref={r => (tilesRefs.current[0] = r)}>
          <ContactInfoIcon type="form" color="black" />
          <div>
            <ContactInfoItemHeading>{writeHeading}</ContactInfoItemHeading>
            <p>{writeParagraph}</p>
          </div>
        </ContactInfoItem>
        <ContactInfoItem ref={r => (tilesRefs.current[1] = r)}>
          <ContactInfoIconChat type="chat" color="black" />
          <div>
            <ContactInfoItemHeading>{locationHeading}</ContactInfoItemHeading>
            <p>{locationParagraph}</p>
          </div>
        </ContactInfoItem>
        <ContactInfoItem ref={r => (tilesRefs.current[2] = r)}>
          <ContactInfoIcon type="contact" color="black" />
          <div>
            <ContactInfoItemHeading>{phoneHeading}</ContactInfoItemHeading>
            <ContactInfoPhoneParagraph>
              {phone}
              <br />
              <ContactInfoMail href={`mailto:${email}`}>
                {email}
              </ContactInfoMail>
            </ContactInfoPhoneParagraph>
          </div>
        </ContactInfoItem>
      </ContactInfoItems>
      {/* <ContactInfoStrokes /> */}
    </ContactInfoContainer>
  )
}

export default ContactInfo
